"use client";

import { useCityPopup } from "../../../_provider/CityPopupProvider";
import { CITIES } from "../../../_constants/cities";
import { useContractorsQuery } from "../_provider/ContractorsQueryProvider";
import Skeleton from "../../../_components/global/Skeleton";
import { inhomzEvents } from "../../../_lib/events";
import { useInhomzTrack } from "../../../_hooks/useInhomzTrack";

// Sits beside FiltersSidebar's "Filters" heading in the content column, at
// the same row — split out of ContractorsListHeader (which now only owns the
// full-width sticky nav bar) so the two can align on desktop.
export default function ContractorsListSummary({ cityParam }) {
  const { selectedCity, openCityPopup } = useCityPopup();
  const { total, isLoading, contractors } = useContractorsQuery();
  const track = useInhomzTrack();

  // Prefer the localStorage-backed selection; fall back to the route's own
  // [city] segment so a direct link still shows a real city label.
  const cityLabel = selectedCity?.label ?? CITIES.find((city) => city.id === cityParam)?.label ?? "your location";

  return (
    <h1 className="m3-title-medium md:m3-headline-small flex items-center gap-2 text-[--textPrimaryPrimary]">
      {isLoading && contractors.length === 0 ? (
        <Skeleton height={24} width={160} />
      ) : (
        <>{total.toLocaleString("en-IN")} Professionals in</>
      )}{" "}
      <button type="button" onClick={() => {
          track(inhomzEvents.contractors.CHANGE_CITY_CLICKED);
          openCityPopup({ changeCity: true });
        }}
        className="underline underline-offset-2">
        {cityLabel}
      </button>
    </h1>
  );
}
